<nav class="my-2 my-md-0 mr-md-3">
  <ng-container *ngIf="emailAddress !== '' && !impersonating">
    <span><b>Logged In As: {{ emailAddress }}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </ng-container>
  <ng-container *ngIf="emailAddress !== '' && impersonating">
    <span class="impersonation-banner"><b><span class="fas fa-user-secret"></span>&nbsp;Impersonating: {{ emailAddress }}</b></span>
    <a class="p-2 text-dark" href="#" (click)="exitImpersonation(); false">
      <span class="fas fa-user-slash"></span>&nbsp;&nbsp;Exit Impersonation
    </a>&nbsp;&nbsp;&nbsp;&nbsp;
  </ng-container>
  <ng-container *ngIf="!loggedIn">
    <a class="p-2 text-dark" [routerLink]="['/login']" (click)="collapse()">
      <span class="fas fa-sign-in-alt"></span>&nbsp;&nbsp;Log In
    </a>
  </ng-container>
  <ng-container *ngIf="!loggedIn">
    <a class="p-2 text-dark" [routerLink]="['/register']" (click)="collapse()">
      <span class="fas fa-user-plus"></span>&nbsp;&nbsp;Register
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && !reportOnly && isInteractiveUser">
    <a class="p-2 text-dark" [routerLink]="['/interactives']">
      <span class="fas fa-chart-bar"></span>&nbsp;&nbsp;My Interactives
    </a>
  </ng-container>
  <!--<ng-container *ngIf="loggedIn && isReportExportUser">
    <a class="p-2 text-dark"
       [routerLink]="['/report-subscriptions']"
       (click)="collapse()">
      <span class="fa fa-clipboard-check"></span>&nbsp;&nbsp;My Reports
    </a>
  </ng-container>-->
  <ng-container *ngIf="loggedIn && hasReportLayouts">
    <a class="p-2 text-dark"
       [routerLink]="['/report-layouts']"
       (click)="collapse()">
      <span class="fa fa-clipboard-check"></span>&nbsp;&nbsp;My Report Layouts
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && hasDodLayouts">
    <a class="p-2 text-dark"
       [routerLink]="['/dod-layouts']"
       (click)="collapse()">
      <span class="fa fa-file-export"></span>&nbsp;&nbsp;My Data Layouts
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && hasPreFilters">
    <a class="p-2 text-dark"
       [routerLink]="['/pre-filters']"
       (click)="collapse()">
      <span class="fa fa-filter"></span>&nbsp;&nbsp;My Pre-Filters
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && hasAiChats">
    <a class="p-2 text-dark"
       [routerLink]="['/reese-chat']"
       (click)="collapse()">
      <span class="fa fa-robot"></span>&nbsp;&nbsp;My AI Chats
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && hasAdmAccess">
    <a class="p-2 text-dark"
       [routerLink]="['/adms']"
       (click)="collapse()">
      <span class="fa fa-table"></span>&nbsp;&nbsp;My ADMs
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && isEmbeddedUser">
    <a class="p-2 text-dark"
       [routerLink]="['/widgets']"
       (click)="collapse()">
      <span class="fa fa-cogs"></span>&nbsp;&nbsp;My Widgets
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && (isInteractiveUser || isReportExportUser)">
    <a class="p-2 text-dark"
       [routerLink]="['/subscription']"
       (click)="collapse()">
      <span class="fas fa-clipboard-list"></span>&nbsp;&nbsp;My Subscriptions
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn">
    <a class="p-2 text-dark"
       [routerLink]="['/preferences']"
       (click)="collapse()">
      <span class="fas fa-sliders-h"></span>&nbsp;&nbsp;Preferences
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn">
    <a class="p-2 text-dark" href="#" (click)="logOut()">
      <span class="fas fa-sign-out-alt"></span>&nbsp;&nbsp;Log Out
    </a>
  </ng-container>
  <ng-container *ngIf="admin || supportAdmin">
    <a class="p-2 text-dark" [routerLink]="['/admin']" (click)="collapse()">
      <span class="fas fa-cogs"></span>&nbsp;&nbsp;Admin
    </a>
  </ng-container>
</nav>
